/* eslint-disable import/no-mutable-exports */
import { BrighterionAuthService } from '@brighterion/br-auth-service';
import { RuleManagementRoleService, UaRoleService } from '@brighterion/br-roles';

export let AuthService: BrighterionAuthService;
export let RoleService: RulesRoleService;

export function setRoleService(roleService: RuleManagementRoleService) {
    const hasReportAccess = roleService.isReportsAdmin() || roleService.isReportsReviewer();
    const hasListAccess = roleService.isListAdmin() || roleService.isListEntriesAdmin() || roleService.isPciAdmin();
    const hasPanListAccess = roleService.isPciAdmin();
    const hasViewRemovedListEntriesAccess =
        roleService.isDesignAdmin() ||
        roleService.isRuleDeployer() ||
        roleService.isListAdmin() ||
        roleService.isListEntriesAdmin() ||
        roleService.isRuleEditor() ||
        roleService.isThresholdEditor() ||
        roleService.isAdvancedRuleEditor();

    const uaRoleService = new UaRoleService(roleService.roles);
    const hasEditRuleOrBulkUploadAccess =
        roleService.isDesignAdmin() ||
        roleService.isRuleEditor() ||
        roleService.isThresholdEditor() ||
        roleService.isAdvancedRuleEditor();
    const hasDesignAccess =
        roleService.isDesignReviewer() || roleService.isRuleDeployer() || hasEditRuleOrBulkUploadAccess;
    const hasListOrDesignAccess = hasListAccess || hasDesignAccess;
    const hasSimpleRuleDeleteAccess =
        roleService.isDesignAdmin() || roleService.isAdvancedRuleEditor() || roleService.isRuleEditor();
    const hasAdvancedRuleDeleteAccess = roleService.isDesignAdmin() || roleService.isAdvancedRuleEditor();
    const hasCreateRuleAccess =
        roleService.isDesignAdmin() || roleService.isRuleEditor() || roleService.isAdvancedRuleEditor();
    const hasCreateAdvancedRuleAccess = roleService.isDesignAdmin() || roleService.isAdvancedRuleEditor();
    const hasRulesUpdateAccess =
        roleService.isDesignAdmin() ||
        roleService.isRuleEditor() ||
        roleService.isAdvancedRuleEditor() ||
        roleService.isThresholdEditor();

    const hasDeployAccess = roleService.isDesignAdmin() || roleService.isRuleDeployer();
    const hasAnyCmsRole = roleService.roles.some((aString) => aString.includes('CASE_'));
    const hasAnyTmRole = roleService.roles.some((aString) => aString.includes('TM_'));
    const hasManageTenantsAccess =
        roleService.isDesignAdmin() ||
        roleService.isRuleEditor() ||
        roleService.isThresholdEditor() ||
        roleService.isDesignReviewer() ||
        roleService.isRuleDeployer() ||
        roleService.isListAdmin() ||
        roleService.isListEntriesAdmin() ||
        roleService.isReportsAdmin() ||
        roleService.isReportsReviewer() ||
        roleService.isAdvancedRuleEditor();

    const hasTenantGroupReadAccess =
        roleService.isDesignAdmin() ||
        roleService.isRuleEditor() ||
        roleService.isThresholdEditor() ||
        roleService.isDesignReviewer() ||
        roleService.isRuleDeployer() ||
        roleService.isAdvancedRuleEditor();

    const hasTenantGroupWriteAccess =
        roleService.isDesignAdmin() ||
        roleService.isRuleEditor() ||
        roleService.isThresholdEditor() ||
        roleService.isAdvancedRuleEditor();

    const isThresholdEditorOnly =
        hasEditRuleOrBulkUploadAccess &&
        !roleService.isDesignAdmin() &&
        !roleService.isRuleEditor() &&
        !roleService.isAdvancedRuleEditor();

    const isParameterAdmin = roleService.isParameterAdmin();
    const isParameterReviewer = roleService.isParameterReviewer();
    const hasParameterAccess = isParameterAdmin || isParameterReviewer;

    const hasAnyRulesRole = hasReportAccess || hasDesignAccess || hasListAccess || hasParameterAccess;
    const hasAnyTenantRole = hasManageTenantsAccess || hasTenantGroupReadAccess || hasTenantGroupWriteAccess;
    const hasViewRuleTestRole = roleService.isRuleDeployer() || roleService.isDesignReviewer();

    const hasRuleTestsEditAccess =
        roleService.isDesignAdmin() ||
        roleService.isAdvancedRuleEditor() ||
        roleService.isRuleEditor() ||
        roleService.isThresholdEditor();

    RoleService = {
        ...roleService,
        hasReportAccess,
        hasDesignAccess,
        hasListAccess,
        hasPanListAccess,
        hasAnyRulesRole,
        hasListOrDesignAccess,
        hasAnyCmsRole,
        hasAnyTmRole,
        hasCreateRuleAccess,
        hasRulesUpdateAccess,
        hasEditRuleOrBulkUploadAccess,
        hasDeployAccess,
        hasManageTenantsAccess,
        hasTenantGroupReadAccess,
        hasTenantGroupWriteAccess,
        hasParameterAccess,
        isThresholdEditorOnly,
        isParameterAdmin,
        isParameterReviewer,
        hasAnyTenantRole,
        hasAdvancedRuleDeleteAccess,
        hasSimpleRuleDeleteAccess,
        hasCreateAdvancedRuleAccess,
        hasViewRuleTestRole,
        hasViewRemovedListEntriesAccess,
        hasRuleTestsEditAccess,
        ...uaRoleService
    };
}

export function setAuthService(authService: BrighterionAuthService) {
    AuthService = authService;
}
